<template>
  <div>
    <BlocoFormularioCadastro voltar="/documento" @salvar="salvar()">
      <template #form>
        <div
          :class="{
            'panel-primary': !v$.documento.$error,
            'panel-danger': v$.documento.$error,
          }"
          class="panel"
        >
          <div class="panel-heading"> Enviar Arquivo </div>
          <div class="panel-body">
            <div class="row">
              <div class="col-xs-6 col-sm-2 col-md-2 col-lg-2">
                <div class="form-group">
                  <label for="regra">Tipo Envio</label>
                  <select
                    v-model="documento.tipoEnvio"
                    data-test-id="select-documento-tipoenvio"
                    class="form-control"
                    @change="tipoEnvioSelecionado"
                  >
                    <option value="paciente"> Paciente </option>
                    <option value="profissional"> Profissional </option>
                  </select>
                </div>
              </div>
              <div
                v-show="documento.tipoEnvio === 'paciente'"
                class="col-xs-12 col-sm-6 col-md-3 col-lg-3"
              >
                <BuscarSelecionarPaciente
                  :minimo="1"
                  label="Paciente"
                  @selecionadoPaciente="pacienteId = $event._id"
                />
              </div>
              <div
                v-show="documento.tipoEnvio === 'profissional'"
                class="col-xs-12 col-sm-6 col-md-3 col-lg-3"
              >
                <BuscarSelecionarProfissional
                  :minimo="1"
                  label="Profissional"
                  @selecionadoProfissional="profissionalId = $event._id"
                />
              </div>
              <div class="col-xs-6 col-sm-2 col-md-2 col-lg-2">
                <div class="form-group">
                  <label for="regra">Tipo de Documento</label>
                  <select
                    v-model="documento.tipo"
                    data-test-id="select-documento-tipo"
                    class="form-control"
                  >
                    <option
                      v-for="tipo in tiposDocumentos"
                      :key="tipo._id"
                      :value="tipo._id"
                    >
                      {{ tipo.valor }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-xs-6 col-sm-2 col-md-2 col-lg-2">
                <label for="arquivo">Selecione o documento</label>
                <input
                  id="arquivo"
                  data-test-id="input-arquivo"
                  type="file"
                  class="form-control"
                  accept=".pdf"
                  @change="aoAlterarArquivo"
                />
              </div>
            </div>
            <p>(1) Campos obrigatórios.</p>
          </div>
        </div>
      </template>
    </BlocoFormularioCadastro>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import AwesomeMask from 'awesome-mask'
import moment from 'moment'

import BuscarSelecionarPaciente from '@/componentes/formulario/BuscarSelecionarPaciente'
import BuscarSelecionarProfissional from '@/componentes/formulario/BuscarSelecionarProfissional'
import { useMenu } from '@/composables/useMenu'
import { cadastroMixin } from '@/mixins/CadastroMixin'
import { dominioMixin } from '@/mixins/DominioMixin'
import DocumentoServico from '@/servicos/DocumentoServico'
import MensagemServico from '@/servicos/MensagemServico'
import PacienteServico from '@/servicos/PacienteServico'
import ProfissionalServico from '@/servicos/ProfissionalServico'

const documentoServico = new DocumentoServico()
const mensagemServico = new MensagemServico()
const pacienteServico = new PacienteServico()
const profissionalServico = new ProfissionalServico()

moment.locale('pt-br')

export default {
  name: 'DocumentoCadastro',
  components: {
    BuscarSelecionarPaciente,
    BuscarSelecionarProfissional,
  },
  directives: { mask: AwesomeMask },
  mixins: [cadastroMixin, dominioMixin],
  setup() {
    useMenu(62)
    return { v$: useVuelidate() }
  },
  data() {
    return {
      consulta: 'Documento',
      entidade: 'documento',
      servico: new DocumentoServico(),
      pacienteId: '',
      profissionalId: '',
      tiposDocumentos: [],
      documento: {
        _id: '',
        tipo: '',
        documento: null,
        tipoEnvio: 'paciente',
      },
    }
  },
  validations: {
    documento: {
      documento: { required },
      tipo: { required },
    },
  },
  created() {
    this.recuperarValoresDominio('TiposDocumentos').then((res) => {
      this.tiposDocumentos = res.valores
    })
  },
  methods: {
    aoAlterarArquivo(event) {
      this.documento.documento = event.target.files[0]
    },
    tipoEnvioSelecionado(event) {
      const tipoEnvio = event.target.value
      if (tipoEnvio === 'paciente') {
        this.profissionalId = ''
      } else {
        this.pacienteId = ''
      }
    },
    async salvar() {
      this.v$.$touch()
      if (this.v$.$invalid) {
        mensagemServico.cadastroInvalido(this.v$)
        return
      }
      const destinoId =
        this.documento.tipoEnvio === 'profissional'
          ? this.profissionalId
          : this.pacienteId
      if (!destinoId) {
        this.$alert(`Selecione o ${this.documento.tipoEnvio}`)
        return
      }

      this.enviando = true
      const data = new FormData()
      data.append('documento', this.documento.documento)
      data.append('tipo', this.documento.tipo)

      try {
        const response = await documentoServico.enviarDocumento(data)
        const documento = response.documento
        if (this.documento.tipoEnvio === 'profissional') {
          await profissionalServico.adicionarDocumentoNoProfissional(
            this.profissionalId,
            documento.id
          )
        } else {
          await pacienteServico.adicionarDocumentoNoPaciente(
            this.pacienteId,
            documento.id
          )
        }
        this.$alert({ content: response.msg }).then(() => location.reload())
      } catch (err) {
        this.$alert(`Erro ao enviar o arquivo ${err}`)
      } finally {
        this.enviando = false
      }
    },
  },
}
</script>
